// src/lib/supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

// --- Safe, Hybrid Environment Variable Access ---

// 1. Check VITE_ prefix (required for the browser/client-side in a Vite app)
const urlVite = import.meta.env.VITE_SUPABASE_URL;
const keyVite = import.meta.env.VITE_SUPABASE_ANON_KEY;

// 2. Check NEXT_PUBLIC_ prefix (your existing convention, used in Vercel Functions)
//    We check this as a fallback in case a build setting exposes it this way,
//    or if the file is imported by a non-Vite part of your stack.
const urlNext = process.env.NEXT_PUBLIC_SUPABASE_URL;
const keyNext = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

// Prioritize the VITE version for the client, then fall back to the NEXT_PUBLIC version.
// This preserves the NEXT_PUBLIC access for any working Serverless Functions.
const url = (typeof urlVite === 'string' && urlVite) ? urlVite : urlNext;
const key = (typeof keyVite === 'string' && keyVite) ? keyVite : keyNext;

// --- Safety Check and Client Creation ---

if (!url || !key) {
  // Log a warning instead of throwing a fatal error, which might crash the app
  // before rendering, but only if we're sure to catch the error elsewhere.
  // Given your app crashes, we'll keep the client creation simple for now.
  console.error("SUPABASE CLIENT ERROR: Required environment variables are missing or undefined.");
}

// NOTE: We use `as string` because TypeScript doesn't know the values exist at runtime.
export const supabase = createClient(url as string, key as string);